import React, { Component } from 'react';

class SecuritySeal extends Component {
  onClick() {
    window.open(
      'https://trustsealinfo.websecurity.norton.com/splash?form_file=fdf/splash.fdf&dn=www.zola.com&lang=en',
      'verisign',
      'scrollbars=yes,resizable=yes,toolbar=0,menubar=0,location=0,status=0,height=500,width=560,top=200,left=200'
    );
  }

  render() {
    return (
      <img
        onClick={this.onClick}
        alt="Norton Secured"
        role="presentation"
        style={{ cursor: 'pointer' }}
        src="/assets/images/norton-seal.png"
      />
    );
  }
}

export default SecuritySeal;



// WEBPACK FOOTER //
// ./src/components/common/SecuritySeal.jsx